import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 12px;
  height: 12px;
  color: #6c6c6c;
`

const Search = ({ title = 'Search', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 15 15" title={title} {...rest}>
    <g strokeWidth={2} stroke="currentColor" fill="none">
      <path d="M11.29 11.71l-4-4" />
      <circle cx={5} cy={5} r={4} />
    </g>
  </StyledIcon>
)

Search.displayName = 'Search'
Search.needsWork = true
export default Search
